import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  overflow: scroll;

  table {
    height: 100%;
  }
  tr {
    height: 50px;
  }
  th {
    width: 200px;
    /* border: 1px solid rgba(255, 255, 255, 0.1); */
  }
  tbody {
    display: flex;
    height: 100%;
    /* border: 1px solid rgba(255, 255, 255, 0.1); */

    button {
      margin: 0 1rem;
      cursor: pointer;
      width: 250px;
      background: transparent;
      color: white;
      border: 2px solid grey;
      border-radius: 8px;
    }
    button:hover{
      border: 2px solid white;
    }

  }
`;
